<template>
  <div id="app">
    <el-container>
<!--     <el-header>
        <NavBar></NavBar>
      </el-header>-->
      <el-container>
<!--        <el-aside width="50px"></el-aside>-->
        <el-main>
          <Home></Home>
          <CallForPapers></CallForPapers>
          <Dates></Dates>
          <Organizers></Organizers>
        </el-main>
      </el-container>
    </el-container>

  </div>
</template>

<script>

import Home from "@/components/Home";
import CallForPapers from "@/components/CallForPapers";
import Dates from "@/components/Dates";
import Organizers from "@/components/Organizers";

export default {
  name: 'App',
  components: {
    Home, CallForPapers, Dates, Organizers
  }
}
</script>

<style>
#app{
  font-family:Verdana,Helvetica,sans-serif;
  font-size:1rem;
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale;
  text-align:left
  }
#app h1{
  font-size:1.7rem
  }
#app h2{
  font-size:1.3rem
  }
#app p,li{
  line-height:1.428571429;
  color:#333
  }
#app .el-table .cell{
  word-break:break-word
  }
</style>
